module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Syriana.b488728.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Syriana.jpg
// module id = nV1G
// module chunks = 0